import { useEffect } from "react";
import { TiaraConfig, updateTiara } from "src/utils/tiara";

export const useTiara = (config: TiaraConfig = {}) => {
  useEffect(() => {
    updateTiara(config);
  }, [config]);
};
